import axios from './ApiService.js';
import { debounce } from '../utils/debounce';

const fetchLibrariesOrRetailers = async (query, type, networkId = null) => {
  if (await debounce(query)) {
    let url = `/api/suggests/${type}.json?query=${encodeURIComponent(query)}`;
    if (networkId !== null) url += `&network_id=${networkId}`;
    const results = await axios.get(url);
    return results.data.data.map(item => ({
      id: item.id,
      name: item.attributes.name
    }));
  }
};

const fetchAllLibrariesOrRetailersByNetwork = async (type, networkId) => {
  if (networkId !== null) {
    const url = `/api/suggests/all_${type}_by_network.json?network_id=${networkId}`;
    const results = await axios.get(url);
    console.log(20, results);
    return results.data;
  }
  return [];
};

// TODO -> I'm almost sure I  don't need the two function below these 
// as they do the sama as this one.
const fetchAllLibrariesOrRetailers = async (type) => {
  const url = `/api/suggests/all_${type}.json`;
  const results = await axios.get(url);
  return results.data;
};

const fetchAllLibraries = async () => {
  const url = `/api/suggests/all_libraries.json`;
  const results = await axios.get(url);
  return results.data;
};

const fetchAllRetailers = async () => {
  const url = `/api/suggests/all_retailers.json`;
  const results = await axios.get(url);
  return results.data;
}

export { 
  fetchLibrariesOrRetailers, 
  fetchAllLibrariesOrRetailersByNetwork, 
  fetchAllLibraries,
  fetchAllRetailers,
  fetchAllLibrariesOrRetailers
};